(function() {

    'use strict';
      
    a3_cabin_reports.filter('search', search);
        
        /**
        * @memberof CabinReports
        * @ngdoc filter
        * @name search
        * @description 
        * @ngInject
        */                       
    function search() {
            /**
             * Filter available toolkit items by search text
             * @param {array} itemArray Array to be filtered
             * @param {string} text Search text input 
             */
            return function(itemArray, text) {
                if(!itemArray || text==undefined || text==null){
                    return [];
                }
                if(!text.length){
                    return itemArray;
                }

                var searchRegex = /[ ,;]+/;
                var searchWords = text.toLowerCase().split(searchRegex);
                searchWords = searchWords.filter(x => x.length>0);
                
                //FOR FUTURE: Add Dynamic fields for search
                return itemArray.filter(x => searchWords.some(y => x.Title.toLowerCase().includes(y)) ||
                                      searchWords.some(y => x.Description.toLowerCase().includes(y)) ||
                                      searchWords.some(y => x.Comments && x.Comments.toLowerCase().includes(y)) ||
                                      searchWords.some(y => x.Tags.some(t => t.toLowerCase().includes(y))));         
            }
        }
    })();
    